import React, { ReactElement, Suspense, lazy } from 'react';
import { Redirect, Route, RouteComponentProps, Router, Switch } from 'react-router-dom';

import ChunkErrorBoundary from '../component/chunkErrorBoundary';
import { retry } from '../utility/retry';
import GAListener from './GAListener';
import history from './history';

const DonationPage = lazy(() => retry(() => import('../page/donationPage')));
const AppContainer = lazy(() => retry(() => import('./AppContainer')));
const ExternalContainer = lazy(() => retry(() => import('./ExternalContainer')));
interface DonationProps {
	fundraiserId: string;
}

const RouterInstance = (): ReactElement => {
	return (
		<Router history={history}>
			<GAListener>
				<ChunkErrorBoundary>
					<Suspense fallback={null}>
					<Switch>
						<Route exact path={['/donation/e/*']} component={ExternalContainer} />
						<Route path={'/*'}>
							<AppContainer>
								<Switch>
									<Route
										path={'/:fundraiserId([0-a-ZA-Z]{4})/join'}
										render={(props: RouteComponentProps<DonationProps>): ReactElement => {
											const fundraiserId = props?.match?.params?.fundraiserId;
											return <DonationPage fundraiserId={fundraiserId} openJoinTeamDialog />;
										}}
									/>
									<Route
										path={'/donation/:fundraiserId([0-a-ZA-Z]{4})/join'}
										render={(props: RouteComponentProps<DonationProps>): ReactElement => {
											const fundraiserId = props?.match?.params?.fundraiserId;
											return <DonationPage fundraiserId={fundraiserId} openJoinTeamDialog />;
										}}
									/>
									<Route
										path={'/:fundraiserId([0-a-ZA-Z]{4})/:parent?/:child?'}
										render={(props: RouteComponentProps<DonationProps>): ReactElement => {
											const fundraiserId = props?.match?.params?.fundraiserId;
											return <DonationPage fundraiserId={fundraiserId} />;
										}}
									/>
									<Route
										path={'/donation/:fundraiserId([0-a-ZA-Z]{4})/:parent?/:child?'}
										render={(props: RouteComponentProps<DonationProps>): ReactElement => {
											const fundraiserId = props?.match?.params?.fundraiserId;
											return <DonationPage fundraiserId={fundraiserId} />;
										}}
									/>
									<Route
										path="/donation/:fundraiserId([0-a-ZA-Z]{4})"
										render={(props: RouteComponentProps<DonationProps>): ReactElement => {
											const fundraiserId = props?.match?.params?.fundraiserId;
											return <DonationPage fundraiserId={fundraiserId} />;
										}}
									/>
									<Redirect from="*" to="/" />
								</Switch>
							</AppContainer>
						</Route>
					</Switch>
					</Suspense>
				</ChunkErrorBoundary>
			</GAListener>
		</Router>
	);
};

export default RouterInstance;
